import { Pipe, PipeTransform } from '@angular/core';

/* eslint-disable */
@Pipe({
	name: 'menuFilter',
	standalone: true,
})
export class MenuFilterPipe implements PipeTransform {
	transform(menu: any[], name: string): any[] {
		const searchArgs = name.toLowerCase().trim();

		if (searchArgs.length >= 3) {
			return menu
				.filter((m) => {
					const state = this.filter(m, searchArgs);
					return state;
				})
				.map((menuItem) => {
					menuItem.expanded = true;
					return menuItem;
				});
		} else {
			menu = menu.map((menuItem) => {
				menuItem.expanded = false;
				return menuItem;
			});
			return menu;
		}
	}

	filter(m: any, searchArgs: string): boolean {
		if (m.children instanceof Array && m.children.length > 0) {
			return m.children.filter((sub: any) => this.filter(sub, searchArgs)).length > 0;
		} else {
			m.name = m.name || '';
			return (m.name as string).toLocaleLowerCase().includes(searchArgs);
		}
	}
}
